const baseSize = 32
const designWidth = 750
// 设置 rem 函数
function setRem () {
 // 页面容器宽度相对于 750 设计宽度的缩放比例，超过设计宽度后不再放大（避免桌面端字体过大）
 const width = Math.min(document.documentElement.clientWidth, designWidth)
 const scale = width / designWidth
 // 设置页面根节点字体大小
 document.documentElement.style.fontSize = (baseSize * scale) + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
 setRem()
}


// WEBPACK FOOTER //
// ./src/rem.js